import { createSlice } from "@reduxjs/toolkit";
import { fetchDepartments } from "./departmentThunks";

const initialState = {
    departments: [],
    loading: false,
    error: null,
};

const departmentSlice = createSlice({
    name: "departments",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDepartments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDepartments.fulfilled, (state, action) => {
                state.loading = false;
                state.departments = action.payload;
            })
            .addCase(fetchDepartments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch departments";
            });
    },
});

export default departmentSlice.reducer;
